<template>
  <div class="row">
    <div class="col-xs-12">
      <h1 class="page-header">{{ title }}</h1>
      <div class="row">
        <div class="form-group col-md-5 pad-left-0 search-margin-left">
          <label for="usuario" class="custom-font">Pesquise por unidade ou nome</label>
            <div class="input-group">
              <input type="text" v-model="termoPesquisa" class="form-control" @keypress.enter="consultar" />
              <span class="input-group-btn">                      
                <button
                  class="btn btn-default"
                  @click="consultar"
                  type="button"
                >
                  <font-awesome-icon :icon="'search'"></font-awesome-icon>
              </button>
            </span>
          </div>
        </div>
        <div class="col-xs-12">
          <list
            ref="vuetable"
            :show-empty="true"
            title="Perfis e unidades"
            :fields="fields"
            :dados="acessos"
            report-title="Perfis e Unidades">
            <template slot="rowrender" slot-scope="props">
              <ul>
                <li>
                  <span class="usuarios-titulo">Nome</span>
                  <span class="usuarios-titulo">Perfil</span>
                </li>
                <li v-for="user in props.rowData.usuarios">
                  <span class="usuarios-dados">{{ user.nome }}</span>
                  <span class="usuarios-dados">{{ user.perfil }}</span>
                </li>  
              </ul>
            </template>
           </list>
        </div> 
      </div>
    </div>
  </div>
</template>

<style scoped>
.custom-font {
  font-size: 16px;
  color: #00615c;
}

ul li {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

ul {
  margin-left: -44px;
}

.usuarios-titulo {
  padding: 5px;
  width: 50%;
  text-align: left;
  font-weight: bold;
}

.usuarios-dados {
  padding: 5px;
  width: 50%;
  text-align: left;
}

.btn-margin {
  margin-top: 28px;
}

.search-margin-left {
  margin-left: 15px;
}
</style>

<script>
import { request } from '@/request'
import list from '@/components/common/NoApiTable'

export default {
  data() {
    return {
      title: 'Relatório de acesso',
      termoPesquisa: '',
      acessos: [],
      loadingScales: false,
      fields: [
        {
          name: 'unidade',
          title: 'Unidade',
          dataClass: 'align-middle',
          filterable: true
        },
        {
          name: '__slot:actions',
          title: 'Usuários com acesso',
          titleClass: 'text-left',
          filterable: true
        }
      ],
    }
  },
  components: {
    list
  },
  beforeCreate() {
    if (!this.$store.state.isLogged) {
      this.$router.push('/login')
    }
  },
  mounted() {
    this.loadAcessos()
  },
  methods: {
    async consultar() {
      const acessos = await this.fetchAcessos()
      const filtersAcesso = acessos.filter(({ unidade, usuarios }) => {
        const unidadeMatch = unidade.toLowerCase().indexOf(this.termoPesquisa.toLowerCase()) > -1
        const usuariosMatch = usuarios.filter(({ nome }) => {
          return nome.toLowerCase().indexOf(this.termoPesquisa.toLowerCase()) > -1
        }).length > 0
        return unidadeMatch || usuariosMatch
      })
      this.acessos = [ ...filtersAcesso ]
    },
    async loadAcessos() {
      const acessos = await this.fetchAcessos()
      this.setAcessos(acessos)
    },
    async fetchAcessos() {
      this.loadingScales = true

      const { data: acessos } = await request.get('escala/listar-unidades-acesso-usuario')

      this.loadingScales = false
      
      return acessos  
    },
    setAcessos(acessos) {
      this.acessos = [ ...acessos ]
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/views/admin/escalas/RelatorioPerfilUnidade.vue